<div class="widget-wrap">
  <!-- Search bar -->
  <div class="search-box">
    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>

    <input #searchInput type="text" class="search-input" placeholder="Search SDKs..." autocomplete="off"
      [(ngModel)]="searchQuery" (ngModelChange)="onQueryChange()" aria-label="Search SDKs" aria-haspopup="listbox" />

    <button *ngIf="searchQuery" class="clear-btn" (click)="clearSearch()" aria-label="Clear search">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>
</div>